export default {
    computed: {
        backgroundThemeClass() {
            return this.backgroundTheme ? `bg-${this.backgroundTheme}` : '';
        },
        borderThemeClass() {
            return this.borderTheme ? `bdc-${this.borderTheme}` : '';
        },
        colorThemeClass() {
            return this.colorTheme ? `clr-${this.colorTheme}` : '';
        },
        shadowThemeClass() {
            return this.shadowTheme ? `shadow-${this.shadowTheme}` : '';
        },
        backgroundHoverClass() {
            return this.hoverBackground ? `bg-hover-${this.hoverBackground}` : '';
        },
        borderHoverClass() {
            return this.hoverBorder ? `bdc-hover-${this.hoverBorder}` : '';
        },
        colorHoverClass() {
            return this.hoverColor ? `clr-hover-${this.hoverColor}` : '';
        },
        shadowHoverClass() {
            return this.hoverShadow ? `shadow-hover-${this.hoverShadow}` : '';
        },
        // eslint-disable-next-line complexity
        themeClasses() {
            const classes = [];

            if (this.backgroundTheme) classes.push(this.backgroundThemeClass);

            if (this.borderTheme) classes.push(this.borderThemeClass);

            if (this.colorTheme) classes.push(this.colorThemeClass);

            if (this.shadowTheme) classes.push(this.shadowThemeClass);

            if (this.bordered) classes.push('bordered');

            if (!(this.disabled || this.loading)) {
                if (this.hoverBackground) classes.push(this.backgroundHoverClass);

                if (this.hoverBorder) classes.push(this.borderHoverClass);

                if (this.hoverColor) classes.push(this.colorHoverClass);

                if (this.hoverShadow) classes.push(this.shadowHoverClass);
            }

            return classes;
        },
        themeData() {
            return {
                bordered: this.bordered,
                backgroundTheme: this.backgroundTheme,
                borderTheme: this.borderTheme,
                colorTheme: this.colorTheme,
                shadowTheme: this.shadowTheme,
                hoverBackground: this.hoverBackground,
                hoverBorder: this.hoverBorder,
                hoverColor: this.hoverColor,
                hoverShadow: this.hoverShadow,
            };
        },
    },
    props: {
        /**
         * Определяет наличие бордера у элемента
         */
        bordered: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        /**
         * Тема (цветовые решения) для цвета фона
         */
        backgroundTheme: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) для цвета бордера
         */
        borderTheme: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) для цвета текста
         */
        colorTheme: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) для тени
         */
        shadowTheme: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) для цвета фона при наведении
         */
        hoverBackground: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) для цвета бордера при наведении
         */
        hoverBorder: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) для цвета текста при наведении
         */
        hoverColor: {
            type: String,
            default: '',
        },
        /**
         * Тема (цветовые решения) для цвета тени при наведении
         */
        hoverShadow: {
            type: String,
            default: '',
        },
    },
};
